import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { brand } from '../theme';
import { optimizedBackground } from '../utils/images';

interface PageLayoutProps {
  /** Centered page heading (orange). */
  title: string;
  /** Source path of the full-bleed background; defaults to the subpage image. */
  background?: string;
  children: React.ReactNode;
}

/**
 * Shared scaffold for the content subpages (About, Team, Projects, Wood): the
 * dark full-bleed brand background, top padding that clears the fixed header,
 * a centered Container, and the page title. Keeps the brand feel identical while
 * removing the per-page duplication.
 */
const PageLayout: React.FC<PageLayoutProps> = ({ title, background = brand.backgrounds.page, children }) => (
  <Box
    sx={{
      backgroundImage: `url(${optimizedBackground(background, 1920)})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      // Parallax feel on desktop; plain scroll on mobile where fixed is janky.
      backgroundAttachment: { xs: 'scroll', md: 'fixed' },
      minHeight: '100vh',
      pt: { xs: 11, md: 14 },
      pb: { xs: 8, md: 12 },
    }}
  >
    <Container maxWidth="lg" sx={{ color: 'common.white' }}>
      <Typography variant="h4" gutterBottom align="center" sx={{ color: brand.orange }}>
        {title}
      </Typography>
      {children}
    </Container>
  </Box>
);

export default PageLayout;
